export default {
  Title: 'New client',
  ClientName: 'Client Name',
  ClientDescription: 'Client Description',
  CreateNewClient: 'Create new client',
};
